module.exports = __webpack_public_path__ + "static/media/Eco Verde 1.b12821f4.jpg";